module.exports = __webpack_public_path__ + "img/verticalLift2.941f75e1.png";